import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  ApiError,
  getGetContactEditSessionQueryKey,
  updateContactBySelf,
  type ContactEditUpdateContactResponse,
  type UpdateContactInput,
} from "@wellcheck/api-client";

/**
 * useUpdateContact — 本人による氏名・メールアドレスの修正 (PATCH /api/contact-edit-session/contact,
 * ADR-0041 Decision 3/6)。
 *
 * PATCH は orval.config.ts の方針 (query.useQuery のみ生成、mutation は低レベル関数を呼び出し側で
 * useMutation にラップ) に従い、生成済みの updateContactBySelf を直接呼ぶ。
 *
 * 成功時のレスポンスは更新後の ContactEditSessionInfo だが、フォームの初期値は
 * GET /api/contact-edit-session の結果を単一ソースとするため invalidate で追従させる。
 */
export function useUpdateContact() {
  const queryClient = useQueryClient();
  return useMutation<ContactEditUpdateContactResponse, ApiError, UpdateContactInput>({
    mutationFn: async (input: UpdateContactInput) => {
      const response = await updateContactBySelf(input);
      if (response.status !== 200) {
        throw new ApiError(response.status, response.data, response.headers);
      }
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: getGetContactEditSessionQueryKey() });
    },
  });
}
